<script setup>
import { ref } from 'vue';
import { useI18n } from 'vue-i18n';

const emit = defineEmits(['update:modelValue', 'update:focused']);
const { t } = useI18n();
defineProps({
    hideLabel: {
        type: Boolean,
        default: false
    }
});

const selected = ref(null);
const types = [
    {
        title: t('Distance'),
        value: 'distance'
    },
    {
        title: t('Volume'),
        value: 'volume'
    },
    {
        title: t('Pieces'),
        value: 'pieces'
    },
    {
        title: t('Flat Rate'),
        value: 'fixed'
    },
    {
        title: t('None'),
        value: 'Ninguna'
    }
];
</script>

<template>
    <v-select
        v-model="selected"
        :items="types"
        :label="hideLabel ? '' : $t('Rate Type')"
        density="compact"
        hide-details
        clearable
        persistent-clear
        @update:modelValue="emit('update:modelValue', selected)"
        @update:focused="(state) => emit('update:focused', state)"
    >
        <template v-if="$slots.prepend" v-slot:prepend>
            <slot name="prepend"></slot>
        </template>
    </v-select>
</template>
